<div class="page">
  <div class='page-wrapper'>
    <div class="body-wrapper">

      <a href="#" routerLink="/store-itens/0">
        <img src="assets/store/_congressos.png">
      </a>
      <a href="#" routerLink="/store-itens/1">
        <img src="assets/store/_cursos.png">
      </a>
      <a href="#" routerLink="/store-itens/2">
        <img src="assets/store/_prova.png">
      </a>
      <a href="#" routerLink="/store-itens/3">
        <img src="assets/store/_anuidade.png">
      </a>

    </div>
  </div>
</div>